<template>
  <div class="setting-bg">
    <q-list>
      <q-item clickable v-ripple>
        <q-item-section>允許顯示非好友貼文</q-item-section>
        <q-item-section avatar>
          <q-toggle v-model="isDisplayNotFriendValue" color="lale-blue" />
        </q-item-section>
      </q-item>
    </q-list>
  </div>
</template>

<script>
export default {
  name: 'Setting',
  data() {
    return {
      isDisplayNotFriendValue: false
    };
  },
  watch: {
    // 監聽 toggle 按鈕的開關
    isDisplayNotFriendValue: function() {
      console.log(this.isDisplayNotFriendValue);
    }
  }
};
</script>

<style lang="scss" scoped>
.setting-bg {
  background-color: $LaleBg;
  height: 100%;
}
</style>

<!-- 全域 -->
<style lang="scss">
.setting-bg {
  .q-list {
    background-color: #ffffff;
  }

  .q-item__section {
    position: relative;
    right: -10px;
  }
}
</style>
